import 'intersection-observer';
import 'url-search-params-polyfill'; // Edge 41 and 42 don't have this
import './utils/array.extensions'
import smoothscroll from 'smoothscroll-polyfill'; // this is for making window.scrollTo work in Edge
smoothscroll.polyfill();